import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mag8",
  "use": "icon-mag8-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mag8\"><path d=\"M906.666667 170.666667H117.333333c-17.706667 0-32 14.293333-32 32v618.666666c0 17.706667 14.293333 32 32 32h789.333334c17.706667 0 32-14.293333 32-32v-618.666666c0-17.706667-14.293333-32-32-32z m-757.333334 64h725.333334v81.813333l-362.666667 201.6-362.666667-201.6V234.666667z m725.333334 554.666666H149.333333V389.653333l347.093334 192.96c4.906667 2.666667 10.24 4.053333 15.573333 4.053334s10.666667-1.386667 15.573333-4.053334L874.666667 389.653333V789.333333z\" p-id=\"14872\" /><path d=\"M489.6 393.6c-6.4 6.4-9.6 12.8-9.6 22.4s3.2 16 9.6 22.4 12.8 9.6 22.4 9.6 16-3.2 22.4-9.6c6.4-6.4 9.6-16 9.6-22.4s-3.2-16-9.6-22.4c-12.8-12.8-32-12.8-44.8 0z\" p-id=\"14873\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-mag8.svg
// module id = BsXz
// module chunks = 175